/*
 * Puts back the review text that the eTrusted review carousel truncates in JS.
 *
 * Its text-clamp element appends words until the text overflows its line budget,
 * then drops the last four characters of what already fit and writes an ellipsis
 * into the text node. Cards come out cut mid-word with the last line half empty,
 * and no CSS can recover characters the widget has already removed. The
 * untouched review is still on the tile, so write it back and let
 * -webkit-line-clamp in etrusted-shops-widgets.css cut at the real line break.
 */
class TrustedShopCarousel extends HTMLElement {
	connectedCallback() {
		const POLL_INTERVAL = 100;
		const MAX_ATTEMPTS = 150;

		let attempts = 0;

		// No ready event to listen for, and attaching a shadow root fires no
		// mutations, so poll until the carousel has one.
		this.poll = setInterval(() => {
			const root = this.carouselRoot;

			if (root) {
				clearInterval(this.poll);
				this.watch(root);
			} else if (++attempts >= MAX_ATTEMPTS) {
				clearInterval(this.poll);
			}
		}, POLL_INTERVAL);
	}

	disconnectedCallback() {
		clearInterval(this.poll);
		this.observer?.disconnect();
	}

	watch(root) {
		const restoreAll = () => {
			root.querySelectorAll('etrusted-rc-carousel-text-clamp').forEach((clamp) => this.restore(clamp));
		};

		// Tiles are built when the carousel first scrolls into view, and rebuilt as
		// it pages, so keep watching rather than sweeping once.
		this.observer = new MutationObserver(restoreAll);
		this.observer.observe(root, { childList: true, subtree: true });
		restoreAll();
	}

	restore(clamp) {
		clamp.style.setProperty('--clamp-lines', `${clamp.lines || 3}`);

		const comment = clamp.closest('etrusted-rc-carousel-review-tile')?.tile?.comment;

		if (!comment || clamp.textContent === comment) return;

		clamp.textContent = comment;
	}

	// theme.liquid opens every etrusted-* shadow root so we can reach inside.
	get carouselRoot() {
		const widget = this.querySelector('etrusted-widget');
		const carousel = widget?.shadowRoot?.querySelector('etrusted-review-carousel-service-widget');

		return carousel?.shadowRoot;
	}
}

if (!customElements.get('trusted-shop-carousel')) {
	customElements.define('trusted-shop-carousel', TrustedShopCarousel);
}
